import Vue from "vue";
import Vuex from "vuex";
import axios from './../plugins/axios.js'

Vue.use(Vuex);
const auth = {
  namespaced: true,
  state: {
    loginInfo: null,
    xAuthToken: null,
    selectedCompanyHash: null,
    selectedCompanyName: null,
    selectedCompanyContracts: null,
    logout: false
  },
  getters: {
    loginInfo: (state) => {
      return state.loginInfo
    },
    xAuthToken: (state) => {
      return state.xAuthToken
    },
    selectedCompanyHash: (state) => {
      return state.selectedCompanyHash
    },
    selectedCompanyName: (state) => {
      return state.selectedCompanyName
    },
    selectedCompanyContracts: (state) => {
      return state.selectedCompanyContracts
    },
    logout: (state) => {
      return state.logout
    }
  },
  mutations: {
    setLoginInfo(state, loginInfo) {
      state.loginInfo = loginInfo
      state.logout = false
    },
    setToken(state, token) {
      state.xAuthToken = token
    },
    setCompanyInfo(state, selectedCompany) {
      state.selectedCompanyHash = selectedCompany.selectedCompanyHash
      state.selectedCompanyName = selectedCompany.selectedCompanyName
      state.selectedCompanyContracts = selectedCompany.selectedCompanyContracts
    },
    clearCompanyInfo(state) {
      state.selectedCompanyHash = null
      state.selectedCompanyName = null
      state.selectedCompanyContracts = null
    },
    clearLoginInfo(state) {
      state.loginInfo = null
      state.xAuthToken = null
      state.selectedCompanyHash = null
      state.selectedCompanyName = null
      state.selectedCompanyContracts = null
      state.logout = true
    }
  },
  actions: {
    login(context, user) {
      context.commit('setLoginInfo', user.loginInfo);
      context.commit('setToken', user.xAuthToken);
    },
    getLoginInfo(context) {
      return axios.get('users/me') // Promiseを返す
        .then(async response => {
          context.commit('setLoginInfo', response.data.content)
        })
        .catch(err => {
          console.log(err);
          throw err;  // エラーが発生した場合、Promiseを拒否
        })
    },
    setCompanyInfo(context, selectedCompany) {
      context.commit('setCompanyInfo', selectedCompany);
    },
    clearCompanyInfo(context) {
      context.commit('clearCompanyInfo');
    },
    logout(context) {
      context.commit('clearLoginInfo');
    }
  }
};

export default auth
